<script>
import { Line } from 'vue-chartjs'

export default {
  name: 'LineChart',
  extends: Line,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    chartoptions: {
      type: Object,
      default: null
    }
  },
  mounted () {
    this.render()
  },
  methods: {
    render() {      
      let tooltips = {
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderWidth: 1,
          borderColor: 'rgba(156, 39, 176, 1)',
          titleFontSize: 14,
          titleFontFamily: 'Montserrat',
          titleFontColor: 'rgba(0, 0, 0, 0.8)',
          bodyFontFamily: 'Montserrat',
          bodyFontSize: 15,
          bodyFontColor: 'rgba(0, 0, 0, 0.8)',
          cornerRadius: 3,
          xPadding: 15,
          yPadding: 15,
          displayColors: false,
          callbacks: this.chartoptions.tooltips.callbacks || null,
      }

      this.chartoptions.tooltips = tooltips
      this.renderChart(this.chartdata, this.chartoptions)
    }
  }
}
</script>
